import { TOGGLE_MOB_LEFT_MENU } from "../actions/types";

export const toogleMenu = (userData) => (dispatch) => {
  if (userData)
    dispatch({
      type: "ToogleSideBar",
      sectionClass: "contentboxcont rd_largcontentboxcont",
    });
  else dispatch({ type: "ToogleSideBar", sectionClass: "contentboxcont" });
};

/**
 * Toggle mobile left menu.
 * Plain action creator — no thunk needed (nothing async happens here).
 * @param {string|null} status  "active" to open, null to close
 */
export const toggleMobileLeftMenu = (status) => ({
  type: TOGGLE_MOB_LEFT_MENU,
  payload: status,
});
